module.exports = __webpack_public_path__ + "static/img/load.8ba9bcf.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/load.gif
// module id = 105
// module chunks = 26